import Vue from 'vue';
import Vuetify from 'vuetify';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

import 'vuetify/dist/vuetify.min.css';
import './styles/vuetify-typography-overrides.css';

Vue.use(Vuetify);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  vuetify,
}).$mount('#app');
